module.exports = __webpack_public_path__ + "img/ring.89f83d8b.svg";